/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import { Router } from '@app';

// Types
import type { TDomainsList } from '@/server/services/Domains';
import type { TDomainsStats } from '@/server/services/Stats';

// App
import Page from '@/client/pages/landing/_layout/_page';

/*----------------------------------
- CONTROLEUR
----------------------------------*/
Router.page('/domains/sector/:sector', ({ api , request }) => {


    return (
        <Page>

        </Page>
    )
});